import { render, staticRenderFns } from "./profileScreenToTab.vue?vue&type=template&id=58419de3&"
import script from "./profileScreenToTab.vue?vue&type=script&lang=js&"
export * from "./profileScreenToTab.vue?vue&type=script&lang=js&"
import style0 from "./profileScreenToTab.vue?vue&type=style&index=0&id=58419de3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports